import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { NavBar, Toast, Skeleton, List, Cell, Empty, Tag, Collapse } from 'react-vant';
import { ArrowLeft, ClockO, Success, Cross, Description } from '@react-vant/icons';
import { getSessionDetail, getAttendanceHistory } from '../../../api/club';
import dayjs from 'dayjs';

const ClubAttendanceHistory = () => {
  const { sessionId } = useParams();
  const navigate = useNavigate();
  const [session, setSession] = useState(null);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, [sessionId]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const [sessionRes, historyRes] = await Promise.all([
        getSessionDetail(sessionId),
        getAttendanceHistory(sessionId)
      ]);
      setSession(sessionRes);
      setHistory(historyRes || []);
    } catch (error) {
      Toast.fail('获取数据失败');
    } finally {
      setLoading(false);
    }
  };

  const getStatusTag = (status) => {
    switch (status) {
      case 'present': return <Tag type="success">出勤</Tag>;
      case 'absent': return <Tag type="danger">缺勤</Tag>;
      case 'late': return <Tag type="warning">迟到</Tag>;
      case 'excused': return <Tag type="primary">请假</Tag>;
      default: return <Tag>{status}</Tag>;
    }
  };

  const getStats = (details) => {
    const total = details.length;
    const present = details.filter(d => d.status === 'present').length;
    const excused = details.filter(d => d.status === 'excused').length;
    return `${present}出勤 / ${excused}请假 / 共${total}人`;
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc' }}>
      <NavBar 
        title={<span style={{ fontWeight: 800 }}>考勤历史</span>} 
        leftText={<ArrowLeft size={20} />} 
        onClickLeft={() => navigate(-1)}
        fixed
        placeholder
      />

      <div style={{ padding: '16px' }}>
        <div style={{ 
          background: '#fff', 
          borderRadius: '16px', 
          padding: '16px', 
          marginBottom: '20px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.03)'
        }}>
          <div style={{ fontSize: '18px', fontWeight: 800, color: '#0f172a', marginBottom: '4px' }}>
            {session?.club_name}
          </div>
          <div style={{ fontSize: '12px', color: '#94a3b8' }}>
            共 {history.length} 条点名记录
          </div>
        </div>

        {loading ? (
          <Skeleton title row={10} />
        ) : history.length === 0 ? (
          <Empty description="暂无考勤记录" />
        ) : (
          <Collapse accordion border={false}>
            {history.map((record, index) => (
              <Collapse.Item
                key={record.id}
                title={
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span style={{ fontWeight: 700, fontSize: '15px' }}>
                      {dayjs(record.attendance_date).format('YYYY-MM-DD')}
                    </span>
                    <span style={{ fontSize: '12px', color: '#94a3b8', fontWeight: 400 }}>
                      {getStats(record.details || [])}
                    </span>
                  </div>
                }
                name={index}
                style={{ marginBottom: '10px', borderRadius: '12px', overflow: 'hidden' }}
              >
                <div style={{ padding: '4px 0' }}>
                  {record.details && record.details.map(detail => (
                    <div 
                      key={detail.id} 
                      style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        padding: '10px 0', 
                        borderBottom: '1px solid #f1f5f9' 
                      }}
                    >
                      <span style={{ fontSize: '14px', color: '#0f172a' }}>{detail.student_name}</span>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {getStatusTag(detail.status)}
                        {detail.notes && <span style={{ fontSize: '12px', color: '#94a3b8' }}>({detail.notes})</span>}
                      </div>
                    </div>
                  ))}
                  {record.notes && (
                    <div style={{ marginTop: '12px', padding: '10px', background: '#f8fafc', borderRadius: '8px', fontSize: '12px', color: '#64748b' }}>
                      备注：{record.notes}
                    </div>
                  )}
                </div>
              </Collapse.Item>
            ))}
          </Collapse>
        )}
      </div>
    </div>
  );
};

export default ClubAttendanceHistory;
